<template>
  <div>
    <el-button-group v-model="selectedCountries">
      <el-button v-if="showAllButton && countries.length > 1" :type="allButtonType" v-on:click="filterPerCountry('All')">Todos</el-button>
      <el-button v-if="countries.length > 1" v-for="country in countries" :key="country.codCountry" :type="getButtonType(country.codCountry)" v-on:click="filterPerCountry(country.codCountry)">{{ getCountryName(country.codCountry) }}</el-button>
    </el-button-group>
  </div>
</template>

<script>
import api from '../../api'
export default {
  name: 'ButtonGroup',
  props: {
    filter: {
      type: Object,
      required: true
    },
    showAllButton: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    allButtonType () {
      return this.selectedCountries.includes('All') ? 'primary' : ''
    },
    countries () {
      return Object.values(this.habilitateFilter)
    }
  },
  data () {
    return {
      selectedCountries: ['All'],
      habilitateFilter: {}
    }
  },
  methods: {
    filterPerCountry (country) {
      this.selectedCountries = [country]
      let filterValue = country === 'All' ? '' : country

      this.$emit('update-filter', {
        ...this.filter,
        value: filterValue
      })
    },
    getButtonType (codCountry) {
      return this.selectedCountries.includes(codCountry) ? 'primary' : ''
    },
    getCountryName (codCountry) {
      // En caso de agregar un nuevo pais en la base de datos debemos agregarlo aca
      if (codCountry === 'AR') {
        return 'Argentina'
      } else if (codCountry === 'PE') {
        return 'Perú'
      }
      return ''
    },
    getHabilitationParams () {
      api
        .request('get', 'api/checkParam?id=FIL-001')
        .then((response) => {
          let data = response.data
          this.habilitateFilter = data
          if (data.error) {
            this.paramInvoices = data.error
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getInitialFilter () {
      setTimeout(() => {
        if (!this.showAllButton) {
          if (this.countries.length === 1 || this.countries.every(country => country.codCountry !== 'AR')) {
            const [firstCountry] = this.countries
            this.selectedCountries = [firstCountry.codCountry]
            this.filterValue = [firstCountry.codCountry]
          } else {
            this.selectedCountries = ['AR']
            this.filterValue = ['AR']
          }
        } else {
          this.selectedCountries = ['All']
          this.filterValue = ['']
        }
        this.$emit('update-filter', {
          ...this.filter,
          value: this.filterValue
        })
      }, 500)
    }
  },
  beforeMount () {
    this.getHabilitationParams()
    this.getInitialFilter()
  }
}
</script>



// WEBPACK FOOTER //
// ButtonGroup.vue?b33cd7f0